import { getUserToken } from './auth.util';

export const getConfig = () => ({
  Authorization: `Bearer ${getUserToken()}`,
});
